import React, { useState, useEffect } from 'react';
import OrderCard from '../components/OrderCard';
import { fetchActiveOrders } from '../services/ordersApi';
import '../styles/kitchen.css';
import { useRef } from 'react';
import { useParams } from "react-router-dom";
import { fetchBranches } from '../services/branchesApi';
import {DragDropContext, Droppable,Draggable,} from "@hello-pangea/dnd";
import { API_BASE_URL, WS_BASE_URL } from '../services/apiConfig';

// Orden de columnas del Kanban para detectar movimientos retrógrados
const COLUMN_ORDER = { PENDING: 0, PREPARING: 1, READY: 2, OUT_FOR_DELIVERY: 3 };

/**
 * KitchenDashboard - Main page component for the kitchen display
 * Shows active orders that need to be prepared
 */
function KitchenDashboard() {
  // State for storing orders
  const [orders, setOrders] = useState([]);
  
  // State for tracking loading status
  const [loading, setLoading] = useState(true);
  
  // State for tracking errors
  const [error, setError] = useState(null);
  
  // State for showing last update time
  const [lastUpdate, setLastUpdate] = useState(null);

  const { branchId } = useParams();
  const [branchName, setBranchName] = useState('');

  // 🔥 NUEVO
const [prevCount, setPrevCount] = useState(0);
const [audioEnabled, setAudioEnabled] = useState(false);

const audioRef = useRef(null);
const audioEnabledRef = useRef(false);

//constante para que cuando llegue un pedido nuevo la tarjeta se resalte unos segundos
const [highlightedOrderId, setHighlightedOrderId] = useState(null);


//esta es otra funcion playsound
const playSound = () => {
  const audio = new Audio("/notification.mp3");

  audio.play().catch(() => {
    console.log("Audio bloqueado por el navegador");
  });
};

  const handleDragEnd = async (result) => {
    if (!result.destination) return;
    if (result.source.droppableId === result.destination.droppableId) return;

    const orderId = result.draggableId;
    const currentStatus = result.source.droppableId;
    const newStatus = result.destination.droppableId;

    // Movimiento retrógrado: pedir confirmación explícita
    const isRetrograde =
      (COLUMN_ORDER[newStatus] ?? 99) < (COLUMN_ORDER[currentStatus] ?? 0);

    if (isRetrograde) {
      const confirmed = window.confirm(
        `⚠️ ¿Regresar la orden #${orderId} de ${currentStatus} a ${newStatus}?\n\n` +
        `Esta acción modifica el historial de tiempos y puede afectar métricas.`
      );
      if (!confirmed) {
        await loadOrders();
        return;
      }
    }

    // Al mover a En Camino: pedir nombre del repartidor
    let delivererName = null;
    if (newStatus === "OUT_FOR_DELIVERY") {
      delivererName = window.prompt(`🚗 Asignar repartidor para orden #${orderId}:\n\nNombre del repartidor:`);
      if (delivererName === null) {
        // El usuario canceló el prompt
        await loadOrders();
        return;
      }
    }

    try {
      const token = sessionStorage.getItem('casapizza_token');
      const body = { status: newStatus };
      if (delivererName) body.deliverer_name = delivererName.trim();

      const response = await fetch(
        `${API_BASE_URL}/panel/orders/${orderId}/status`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        alert(`❌ No se puede cambiar el estado:\n${error.detail}`);
      }

      await loadOrders();
    } catch (err) {
      console.error("Error updating status", err);
      await loadOrders();
    }
  };

const loadOrders = async () => {
  try {

    setError(null);

    const fetchedOrders = await fetchActiveOrders(branchId);

    //setOrders([...fetchedOrders]);
    setOrders(fetchedOrders.orders || []);

    setLastUpdate(new Date());

    setLoading(false);

  } catch (err) {

    console.error('Failed to load orders:', err);

    setError('Error al cargar las órdenes. Reintentando...');

    setLoading(false);
  }
};

  /**
   * Effect hook - Loads orders on mount and sets up polling
   */
  useEffect(() => {
    loadOrders();
    fetchBranches().then(branches => {
      const found = branches.find(b => b.id === parseInt(branchId));
      setBranchName(found?.name || branchId);
    });
  }, [branchId]);

  // 🔥 WEBSOCKET (AGREGAR AQUÍ)
const wsRef = useRef(null);

useEffect(() => {
  if (wsRef.current) return;

  const token = sessionStorage.getItem('casapizza_token');
  const ws = new WebSocket(`${WS_BASE_URL}/ws/orders/${branchId}?token=${token}`);
  wsRef.current = ws;

  

  ws.onopen = () => {};

  ws.onmessage = (event) => {
  const data = JSON.parse(event.data);

  // 🔥 SOLO cuando hay cambios relevantes
  if (data.type === "NEW_ORDER" || data.type === "ORDER_UPDATED") {
    loadOrders(); // 🔥 CLAVE
  }

  // 🔴 highlight solo para nuevas órdenes
  if (data.type === "NEW_ORDER") {
    setHighlightedOrderId(data.order_id);

    setTimeout(() => {
      setHighlightedOrderId(null);
    }, 3000);
  }

  // 🔊 sonido solo en nuevas órdenes
  if (data.type === "NEW_ORDER" && audioEnabledRef.current) {
    playSound();
  }
};

  ws.onclose = () => {};

  // 🔥 heartbeat (mantener conexión viva)
  const intervalPing = setInterval(() => {
    if (wsRef.current?.readyState === 1) {
    wsRef.current.send("ping");
  }
}, 5000);

return () => {
    clearInterval(intervalPing);
  };

}, []);

  /**
   * Formats the last update time for display
   */
  const formatLastUpdate = () => {
    if (!lastUpdate) return '';
    
    const hours = lastUpdate.getHours().toString().padStart(2, '0');
    const minutes = lastUpdate.getMinutes().toString().padStart(2, '0');
    const seconds = lastUpdate.getSeconds().toString().padStart(2, '0');
    
    return `${hours}:${minutes}:${seconds}`;
  };

  /**
   * Groups orders by status for better organization
   */
   const groupOrdersByStatus = () => {
     const grouped = {
       PENDING: [],
       PREPARING: [],
       READY: [],
       OUT_FOR_DELIVERY: [],
     };

     const today = new Date();

     const todayOrders = orders.filter((order) => {
       const created = new Date(order.created_at);

       return (
         created.getFullYear() === today.getFullYear() &&
         created.getMonth() === today.getMonth() &&
         created.getDate() === today.getDate()
       );
     });

     todayOrders.forEach((order) => {
       if (grouped[order.status]) {
         grouped[order.status].push(order);
       }
     });

     Object.keys(grouped).forEach((status) => {
       grouped[status].sort(
         (a, b) => new Date(a.created_at) - new Date(b.created_at),
       );
     });

     return grouped;
   };
  /**
  const groupOrdersByStatus = () => {
    const grouped = {
      PENDING: [],
      PREPARING: [],
      READY: []
    };

    orders.forEach(order => {
      if (grouped[order.status]) {
        grouped[order.status].push(order);
      }
    });

    return grouped;
  };*/

  const groupedOrders = groupOrdersByStatus();

  const visibleOrdersCount =
  groupedOrders.PENDING.length +
  groupedOrders.PREPARING.length +
  groupedOrders.READY.length +
  groupedOrders.OUT_FOR_DELIVERY.length;

  /**
   * Render loading state
   */
  if (loading) {
    return (
      <div className="kitchen-dashboard">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Cargando órdenes...</p>
        </div>
      </div>
    );
  }

  /**
   * Main render
   */
  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div className="kitchen-dashboard">
        {/* Header */}
        <header className="dashboard-header">
          <h1 className="dashboard-title">
            🍕 Cocina {branchName}
          </h1>

          <div className="dashboard-info">
            <div className="order-count">
              <span className="count-number">{visibleOrdersCount}</span>
              <span className="count-label">
                {orders.length === 1 ? "orden activa" : "órdenes activas"}
              </span>
            </div>

            {lastUpdate && (
              <div className="last-update">
                Actualizado: {formatLastUpdate()}
              </div>
            )}

            {/* 🔊 BOTÓN DE AUDIO */}
            {!audioEnabled && (
              <button
                onClick={() => {
                  const audio = new Audio("/notification.mp3");

                  audio
                    .play()
                    .then(() => {
                      audio.pause();
                      audio.currentTime = 0;

                      audioRef.current = audio;

                      setAudioEnabled(true);
                      audioEnabledRef.current = true; // 🔥 AQUÍ MISMO

                      console.log("🔊 audio activado");
                    })
                    .catch(() => {
                      console.log("El navegador bloqueó el audio");
                    });
                }}
              >
                🔊 Activar sonido
              </button>
            )}
          </div>
        </header>

        {/* Error message */}
        {error && <div className="error-banner">⚠️ {error}</div>}

        {/* Main content */}
        <main className="dashboard-content">
          {orders.length === 0 ? (
            <div className="no-orders">
              <div className="no-orders-icon">✓</div>
              <h2>No hay órdenes activas</h2>
              <p>Todas las órdenes han sido procesadas</p>
            </div>
          ) : (
            <div style={{ display: "flex", gap: 20, padding: 20 }}>
              {/* PENDING */}
              <Droppable droppableId="PENDING">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      flex: 1,
                      background: "#fff3cd",
                      padding: 10,
                      borderRadius: 10,
                    }}
                  >
                    <h2>🕒 Pendientes ({groupedOrders.PENDING.length})</h2>

                    {groupedOrders.PENDING.map((order, index) => (
                      <Draggable
                        key={order.id}
                        draggableId={order.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <OrderCard
                              order={order}
                              isHighlighted={order.id === highlightedOrderId}
                              reloadOrders={loadOrders}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>

              {/* PREPARING */}
              <Droppable droppableId="PREPARING">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      flex: 1,
                      background: "#cfe2ff",
                      padding: 10,
                      borderRadius: 10,
                    }}
                  >
                    <h2>
                      👨‍🍳 En preparación ({groupedOrders.PREPARING.length})
                    </h2>

                    {groupedOrders.PREPARING.map((order, index) => (
                      <Draggable
                        key={order.id}
                        draggableId={order.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <OrderCard
                              order={order}
                              isHighlighted={order.id === highlightedOrderId}
                              reloadOrders={loadOrders}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>

              {/* READY */}
              <Droppable droppableId="READY">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      flex: 1,
                      background: "#d1e7dd",
                      padding: 10,
                      borderRadius: 10,
                    }}
                  >
                    <h2>✅ Listos ({groupedOrders.READY.length})</h2>

                    {groupedOrders.READY.map((order, index) => (
                      <Draggable
                        key={order.id}
                        draggableId={order.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <OrderCard
                              order={order}
                              isHighlighted={order.id === highlightedOrderId}
                              reloadOrders={loadOrders}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>

              {/* OUT_FOR_DELIVERY */}
              <Droppable droppableId="OUT_FOR_DELIVERY">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      flex: 1,
                      background: "#ede9fe",
                      padding: 10,
                      borderRadius: 10,
                    }}
                  >
                    <h2>🚗 En Camino ({groupedOrders.OUT_FOR_DELIVERY.length})</h2>

                    {groupedOrders.OUT_FOR_DELIVERY.map((order, index) => (
                      <Draggable
                        key={order.id}
                        draggableId={order.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <OrderCard
                              order={order}
                              isHighlighted={order.id === highlightedOrderId}
                              reloadOrders={loadOrders}
                            />
                            {order.deliverer_name && (
                              <div style={{
                                fontSize: 11, color: "#6d28d9", fontWeight: "bold",
                                padding: "2px 8px 6px 8px",
                              }}>
                                🚗 {order.deliverer_name}
                              </div>
                            )}
                          </div>
                        )}
                      </Draggable>
                    ))}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          )}
        </main>
      </div>
    </DragDropContext>
  );
}

export default KitchenDashboard;